import { FunctionComponent } from 'react'

type CounterBarProps = {
	numWordsRemaining: number
}

const CounterBar: FunctionComponent<CounterBarProps> = ({ numWordsRemaining }) => (
	<div className="counter-bar">
		{numWordsRemaining > 0 && <span className="counter">{numWordsRemaining}</span>}
		<span>{numWordsRemaining > 0 ? 'words remaining' : 'All done!'}</span>
	</div>
)

export default CounterBar
